/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for AccountingPeriod controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { UpdateAccountingPeriodRequest, RequestOptions, GetAccountingPeriodsResponse, CreateAccountingPeriodRequest, CreateAccountingPeriodResponse } from "../models";

@Injectable({ providedIn: "root" })
export class AccountingPeriodService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    updateAccountingPeriod(id: number, updateAccountingPeriodRequest: UpdateAccountingPeriodRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateAccountingPeriod(id: number, updateAccountingPeriodRequest: UpdateAccountingPeriodRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateAccountingPeriod(id: number, updateAccountingPeriodRequest: UpdateAccountingPeriodRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateAccountingPeriod(id: number, updateAccountingPeriodRequest: UpdateAccountingPeriodRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/AccountingPeriod/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateAccountingPeriodRequest, requestOptions);
    }

    getAccountingPeriods(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetAccountingPeriodsResponse>;
    getAccountingPeriods(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetAccountingPeriodsResponse>>;
    getAccountingPeriods(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetAccountingPeriodsResponse>>;
    getAccountingPeriods(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/AccountingPeriod`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createAccountingPeriod(createAccountingPeriodRequest: CreateAccountingPeriodRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateAccountingPeriodResponse>;
    createAccountingPeriod(createAccountingPeriodRequest: CreateAccountingPeriodRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateAccountingPeriodResponse>>;
    createAccountingPeriod(createAccountingPeriodRequest: CreateAccountingPeriodRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateAccountingPeriodResponse>>;
    createAccountingPeriod(createAccountingPeriodRequest: CreateAccountingPeriodRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/AccountingPeriod`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createAccountingPeriodRequest, requestOptions);
    }
}
